import React from 'react'
import styled from 'styled-components'
import {ListDivider as RmwcListDivider} from '@rmwc/list'
import '@rmwc/list/styles'

const StyledRmwcListDivider = styled(RmwcListDivider)``

const ListDivider = (props) => <StyledRmwcListDivider {...props} />

export {ListDivider}
